import React from 'react';

const AlertSettingsContext = React.createContext();
export default AlertSettingsContext;
